export enum PhysicalKeys {
  TechInstructions = 'tech_instructions',
  Standards = 'standards',
  Control = 'control',
}
